export function getVersion() {
    const date_now = new Date();
    const date_string =  date_now.getFullYear().toString().slice(-2)
    + (date_now.getMonth()+1).toString().padStart(2, 0)
    + date_now.getDate().toString().padStart(2, 0)
    + date_now.getHours().toString().padStart(2, 0)
    + date_now.getMinutes().toString().padStart(2, 0)
    + date_now.getSeconds().toString().padStart(2, 0);
    return date_string;
}

export function getLanguageToDisplay(languages, default_language) {
    if(default_language) return default_language;
    return languages[0]
}

export function getTextSetting(language, setting_key, question) {
    if(language&&question[`${setting_key}::${language}`]) {
        return question[`${setting_key}::${language}`];
    }
    return question[setting_key];
}

export function hasLanguage(languages) {
    return languages.length > 0 || (languages.length==1 && languages[0]!=="");
}